/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 字符串加解密工具
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-15 20:57:23
 * @LastEditTime: 2022-06-22 16:47:06
 * @FilePath: /client-h5-v2/src/common-ts/secret.ts
 */
import CryptoJS from 'crypto-js'

// 加解密key值
const key = CryptoJS.enc.Utf8.parse('moli123qwe456asd')

export default {
  // 加密
  EncryptData (data: string): string {
    const srcs = CryptoJS.enc.Utf8.parse(data)
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  },
  // 解密
  DecryptData (data: string): string {
    const decrypt = CryptoJS.AES.decrypt(data, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return JSON.parse(CryptoJS.enc.Utf8.stringify(decrypt).toString())
  }
}
